export default __webpack_public_path__ + "static/shipping-6-fdead5c84d5acb3246b26899b1095f4d.jpg";